import { FC } from "react";
import { IOperatorInvoicePreviewOperator } from "../../interfaces/endpoints/IOperatorInvoice";

const formatMoney = (value: number) => `${(value ?? 0).toFixed(2)} EUR`;

// Per-operator subtotal breakdown shown above the row tables for a combined preview.
const OperatorBreakdownTable: FC<{
  operators: IOperatorInvoicePreviewOperator[];
}> = ({ operators }) => (
  <div className="overflow-auto border rounded-md">
    <table className="w-full text-sm">
      <thead className="bg-gray-50 text-xs uppercase text-gray-500">
        <tr>
          <th className="text-left p-2">Operatori</th>
          <th className="text-right p-2">Total</th>
          <th className="text-right p-2">Komisioni</th>
          <th className="text-right p-2">Anulime</th>
          <th className="text-right p-2">Neto</th>
        </tr>
      </thead>
      <tbody>
        {operators.map((op) => (
          <tr key={op.operatorId} className="border-t hover:bg-gray-50">
            <td className="p-2">{op.operatorName}</td>
            <td className="p-2 text-right">{formatMoney(op.totalPrice)}</td>
            <td className="p-2 text-right">
              {formatMoney(op.totalGjirafaCommission)}
            </td>
            <td className="p-2 text-right">
              {formatMoney(op.totalCancellations)}
            </td>
            <td className="p-2 text-right font-medium">
              {formatMoney(op.netBillable)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default OperatorBreakdownTable;
